import { createQueryHook } from '../../createQueryHook'
import { RequiredDocument } from '../../types'

export default createQueryHook<{ applicationId: string }, RequiredDocument[]>({
  getKey: ({ applicationId }) => [`app/requirements?applicationId=${applicationId}`],
  getEndpoint: ({ applicationId }) => `app/requirements?applicationId=${applicationId}`
})
